"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.is-array");

exports.__esModule = true;
exports["default"] = isOneOf;

function isOneOf(one, ofTarget) {
  if (Array.isArray(ofTarget)) {
    return ofTarget.indexOf(one) >= 0;
  }

  return one === ofTarget;
}